module.exports = __webpack_public_path__ + "static/img/16bg.5004b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/16bg.png
// module id = NBp5
// module chunks = 1